import React from 'react';
import { Calendar, User, ArrowRight } from 'lucide-react';

const mockPosts = [
  {
    id: 1,
    title: 'Como o Planejamento Tributário pode salvar sua empresa em 2026',
    excerpt: 'Descubra estratégias legais para reduzir a carga de impostos e aumentar a margem de lucro do seu negócio neste ano.',
    category: 'Tributário',
    date: '25 Abr 2026',
    author: 'João Costa',
    readTime: '5 min'
  },
  {
    id: 2,
    title: 'A Nova Lei Trabalhista e o Home Office: O que muda?',
    excerpt: 'Um guia completo sobre as novas regulamentações para o trabalho remoto e como adequar o departamento pessoal da sua empresa.',
    category: 'Trabalhista',
    date: '18 Abr 2026',
    author: 'Maria Silva',
    readTime: '8 min'
  },
  {
    id: 3,
    title: 'BPO Financeiro: Quando é a hora de terceirizar?',
    excerpt: 'Entenda os sinais de que sua empresa precisa de ajuda profissional para gerenciar o fluxo de caixa e as finanças do dia a dia.',
    category: 'Financeiro',
    date: '10 Abr 2026',
    author: 'Carlos Mendes',
    readTime: '6 min'
  }
];

export default function BlogList() {
  return (
    <div className="bg-slate-50 min-h-screen py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-16 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-navy mb-4">Blog e Insights</h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Artigos, guias e novidades sobre contabilidade, gestão e negócios escritos por nossos especialistas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 hover:shadow-lg transition-shadow flex flex-col">
              <div className="mb-4 flex items-center justify-between">
                <span className="px-3 py-1 bg-orange-100 text-orange-600 text-xs font-bold rounded-full uppercase tracking-wider">
                  {post.category}
                </span>
                <span className="text-xs text-slate-400 font-medium">{post.readTime} leitura</span>
              </div>
              
              <h2 className="text-xl font-bold text-navy mb-3 leading-tight line-clamp-3">
                {post.title}
              </h2>
              
              <p className="text-slate-600 text-sm mb-6 flex-1 line-clamp-4">
                {post.excerpt}
              </p>
              
              <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between">
                <div className="flex flex-col">
                  <div className="flex items-center text-xs text-slate-500 gap-1 mb-1">
                    <User size={12} />
                    <span>{post.author}</span>
                  </div>
                  <div className="flex items-center text-xs text-slate-500 gap-1">
                    <Calendar size={12} />
                    <span>{post.date}</span>
                  </div>
                </div>
                <button className="w-8 h-8 rounded-full bg-slate-50 text-navy flex items-center justify-center hover:bg-orange-500 hover:text-white transition-colors">
                  <ArrowRight size={16} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
